<div class="menu-box" [ngStyle]="{'color': settingsData?.form_font_secondary_color,
'background-color': settingsData?.form_bg_color}">
  <div fxLayout="row" class="menu-header w-100">
    <div fxFlex="80%">
      <h6 class="fs-16 ff fw-500 c-p" [ngStyle]="{'color': settingsData?.form_font_secondary_color }">
        Tips
      </h6>
    </div>
    <div fxFlex="20%" class="text-right lh-19 pointer">
      <span (click)="closeDialog()" [ngStyle]="{'color': settingsData?.form_font_secondary_color }">
        <!-- <app-svg [icon]="'live-stream-close-icon-white'"></app-svg> -->
         <mat-icon>close</mat-icon>
      </span>
    </div>
  </div>
  <app-payment [activeBlock]="'Tips'" [isFromCommunityTips]="isFromCommunityTips" [settingsData]="settingsData">
  </app-payment>
</div>